document.addEventListener('DOMContentLoaded', () => {
  const section = document.querySelector(
    '#shopify-section-template--31336779579678__multicolumn_JFLiy8'
  );

  if (!section) return;

  const slider = section.querySelector('.multicolumn-list');
  const cards = slider?.querySelectorAll('.multicolumn-list__item');

  if (!slider || !cards?.length) return;

  /* Create navigation */
  const nav = document.createElement('div');
  nav.className = 'ck9-brand-nav';

  const prev = document.createElement('button');
  prev.className = 'ck9-brand-arrow ck9-brand-prev';
  prev.type = 'button';
  prev.setAttribute('aria-label', 'Previous brands');
  prev.innerHTML = '&#8592;';

  const next = document.createElement('button');
  next.className = 'ck9-brand-arrow ck9-brand-next';
  next.type = 'button';
  next.setAttribute('aria-label', 'Next brands');
  next.innerHTML = '&#8594;';

  nav.append(prev, next);

  /* Put arrows below carousel */
  slider.insertAdjacentElement('afterend', nav);

  function getScrollAmount() {
    const card = cards[0];
    const styles = window.getComputedStyle(slider);
    const gap = parseFloat(styles.columnGap || styles.gap) || 0;

    return card.getBoundingClientRect().width + gap;
  }

  prev.addEventListener('click', () => {
    slider.scrollBy({
      left: -getScrollAmount(),
      behavior: 'smooth'
    });
  });

  next.addEventListener('click', () => {
    slider.scrollBy({
      left: getScrollAmount(),
      behavior: 'smooth'
    });
  });
});